module.exports = __webpack_public_path__ + "static/logo-53799b8d28325f1bd98596e4d38711cd.png";